export function initNavigation() {
    $('#togglemenu').click(function (e) {
        e.preventDefault();
        const menuBtn = document.querySelector('#togglemenu');
        const icon = $('#togglemenu>img');
        const menu = document.querySelector('.o-navigation');
        let path = icon.attr('src');
        const header = document.querySelector('.a-logolink');
        const body = document.querySelector('body');
        let pathTree = path.split('/');
        menu.classList.toggle('open');

        /* öffnen */
        if (menu.classList.contains('open')) {
            $('.o-navigation').fadeIn(200);
            let menu = 'menu_close.svg';
            if ($('.o-section_orange.header').length){
                $('.a-logolink img').attr('src','/typo3conf/ext/boy_template/Resources/Public/Theme/prod/assets/img/boy_logo_n.svg')
            }  
            pathTree[pathTree.length - 1] = menu;
            header.classList.add('fixed');
            menuBtn.classList.remove('blend');
            body.classList.add('no-scroll');
        } else {
            /* schließen */
            $('.o-navigation').fadeOut(200);
            let menu = 'menu.svg';
            if ($('.o-section_orange.header').length){
                $('.a-logolink img').attr('src','/typo3conf/ext/boy_template/Resources/Public/Theme/prod/assets/img/boy_logo_n-or.svg')
            }
            /*if ($('.m-slider_introslider').length){
                $('.a-logolink img').attr('src','/typo3conf/ext/boy_template/Resources/Public/Theme/dev/assets/img/boy_logo_n-negative.svg')
            }  */
            menuBtn.classList.add('blend');
            header.classList.remove('fixed');
            body.classList.remove('no-scroll');
            pathTree[pathTree.length - 1] = menu;
        }
        const newPath = pathTree.join('/');
        icon.attr('src', newPath);
    });
}